import StaffAsyncActionModal from "./StaffAsyncActionModal";

export function getStaffApiErrorCopy(
  res,
  title = "We could not finish this",
) {
  const msg = String(res?.msg || "The request failed or timed out");
  return {
    phase: "error",
    kind: "api_error",
    title,
    text: `${msg}. That is not an airline decline. Try again.`,
  };
}

export default function StaffApiErrorModal({
  open,
  setOpen,
  title,
  text,
}) {
  const copyTitle = title || "We could not finish this";

  function close() {
    setOpen?.(false);
  }

  return (
    <StaffAsyncActionModal
      open={open}
      setOpen={(next) => {
        if (!next) close();
      }}
      title={copyTitle}
      phase="error"
      resultTitle={copyTitle}
      resultText={text}
      actions={[{ label: "OK", primary: true, onClick: close }]}
    />
  );
}
